import { useMutation } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";

/** Envelope-unwrapped body of `GET /api/v1/auth/legal-documents/{type}/download-url`. */
export interface LegalDocumentUrlData {
  download_url: string;
  expires_in: number;
  /** Informational — the version actually recorded is resolved server-side. */
  version: string;
}

/** The document types the sign-up form links. `data_responsibility` is a
 *  sentence on the form, not a hosted document, so it is deliberately absent. */
export type LegalDocumentType = "dpa" | "terms_of_use" | "privacy_policy";

// Mint a pre-signed S3 GET URL for one CITS legal document (Story 16.8).
//
// A MUTATION, never useQuery: a pre-signed URL is short-TTL, so it must never be
// cached and must be re-minted per click (an expired URL is therefore never an
// issue). It is also 1:1 with a deliberate click — nothing auto-fires on mount.
//
// `skipAuthRefresh: true` — this endpoint is PUBLIC and the caller is on the
// sign-up form with no session at all. Without it a failure would be routed
// through the silent-refresh path, turning a document outage into a spurious
// auth error for someone who has no account yet.
export function useLegalDocument() {
  return useMutation({
    mutationFn: (documentType: LegalDocumentType) =>
      apiFetch<LegalDocumentUrlData>(
        `/auth/legal-documents/${documentType}/download-url`,
        { skipAuthRefresh: true },
      ),
  });
}
